// LICENSE_CODE ZON
'use strict';

/*jslint node:true, es6:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useCallback, useContext } from 'react';
import cn from 'classnames';
import _debounce from 'lodash.debounce';
import { Trans as T, useTranslation } from 'react-i18next';
import { capitalize } from '/util/string.js';
import etask from '/util/etask.js';
import { fetch } from '/util/fetch.js';
import { Settings_context } from '../settings_ctx';
import Info from '../../../toolip/pub/img/icons/info.svg';
import styles from './pass_meter.module.less';
var default_messages = {
  'weak': 'Not quite',
  'medium': 'Almost there',
  'good': 'Just a bit more',
  'perfect': 'Perfect!'
};
export var Pass_meter = props => {
  useTranslation();
  var pass = props.pass,
    email = props.email,
    _props$messages = props.messages,
    messages = _props$messages === void 0 ? default_messages : _props$messages;
  var _useState = useState('empty'),
    _useState2 = _slicedToArray(_useState, 2),
    strength = _useState2[0],
    set_strength = _useState2[1];
  var msg = messages[strength] || capitalize(strength);
  var check_pass = useCallback(_debounce(_pass => etask(function* () {
    if (!_pass) return void set_strength('empty');
    try {
      var res = yield fetch('/users/check_pass', {
        method: 'POST',
        body: {
          pass: _pass,
          email
        }
      });
      set_strength(res);
    } catch (e) {}
  }), 500), []);
  useEffect(() => {
    check_pass(pass);
  }, [pass]);
  var cls = cn('pass_meter', styles.wrapper);
  return pass && /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.meter
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.filler, styles[strength])
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.msg
  }, /*#__PURE__*/React.createElement(T, null, msg)))));
};
export var Pass_meter_2023 = props => {
  useTranslation();
  var _useContext = useContext(Settings_context),
    theme = _useContext.theme;
  var pass = props.pass,
    email = props.email,
    bars = props.bars,
    _props$messages2 = props.messages,
    messages = _props$messages2 === void 0 ? default_messages : _props$messages2,
    _props$show_messages = props.show_messages,
    show_messages = _props$show_messages === void 0 ? true : _props$show_messages,
    _props$show_requireme = props.show_requirements,
    show_requirements = _props$show_requireme === void 0 ? true : _props$show_requireme;
  var _useState3 = useState('empty'),
    _useState4 = _slicedToArray(_useState3, 2),
    strength = _useState4[0],
    set_strength = _useState4[1];
  var msg = messages[strength] || capitalize(strength);
  var check_pass = useCallback(_debounce((_pass, _e) => etask(function* () {
    if (!_pass) return void set_strength('empty');
    try {
      var res = yield fetch('/users/check_pass', {
        method: 'POST',
        body: {
          pass: _pass,
          email: _e
        }
      });
      set_strength(res);
    } catch (e) {}
  }), 500), []);
  useEffect(() => {
    check_pass(pass, email);
  }, [pass, email]);
  var cls = cn('pass_meter', styles.wrapper, styles.wrapper_2023, styles[strength], !pass && styles.empty);
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.meter_2023
  }, bars ? /*#__PURE__*/React.createElement("div", {
    className: styles.bars,
    "data-role": "bars"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar1)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar2)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar3)
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.bar, styles.bar4)
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles.filler
  }), strength != 'empty' && show_messages ? /*#__PURE__*/React.createElement("p", {
    className: theme.p5,
    "data-role": "strength"
  }, "Password strength: ", /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(T, null, msg))) : /*#__PURE__*/React.createElement("p", {
    className: theme.p5
  }, "\xA0"), show_requirements && (props.requirements || /*#__PURE__*/React.createElement("div", {
    className: styles.info_meter
  }, /*#__PURE__*/React.createElement(Info, {
    width: "20"
  }), /*#__PURE__*/React.createElement("p", {
    className: theme.p5
  }, "At least 8 characters, a combination of upper and lower-case letters, numbers and special characters.")))));
};